import { render, staticRenderFns } from "./ToggleCard.vue?vue&type=template&id=64c52938&"
import script from "./ToggleCard.vue?vue&type=script&lang=js&"
export * from "./ToggleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports